import styled from '@emotion/styled';
import { Box } from '@mui/material';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

export const ResultsTabs = styled(props => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className='MuiTabs-indicatorSpan' /> }}
  />
))({
  '& .MuiTabs-indicator': {
    backgroundColor: '#A692F8'
  }
});

export const ResultTab = styled(props => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    color: 'white',
    fontSize: '14px',
    fontWeight: '400',
    textTransform: 'none',
    '&.Mui-selected': {
      color: '#A692F8',
      fontWeight: '400'
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'rgba(100, 95, 228, 0.32)'
    }
  })
);

export const ResultBox = styled(props => <Box {...props} />)(({ theme }) => ({
  borderBottom: 1,
  borderColor: 'divider'
}));
